export const initialState = {
  isAuth: false,
  isBanned: false,
  isProcess: false,
  notifications: [],
  seendNotifications: [],
  loginFailedAttempts: 0,
  semiAutoWithdrawalEnabled: false,
  isHigherAgentsOperationsRestricted: false,
  actionProcessing: false,
  maxDeposit: null,
};
